export default __webpack_public_path__ + "static/media/photo--sm--37.964adc26.jpg";